import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import {
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  Alert,
  Box,
} from '@mui/material';
import { identityApi } from '../api/identityApi'; // Import identityApi client
import { logError } from '../utils/logging'; // Import logError

function ForgotPassword() {
  const navigate = useNavigate();

  
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // Use 'idle', 'submitting', 'success', 'error'
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setError('Please enter your email address');
      return;
    }

    setStatus('submitting');
    setError('');

    try {
      await identityApi.forgotPassword(email);
      
      setStatus('success');
      setSuccess('Password reset email sent! Please check your email.');
      
    } catch (err) {
      setStatus('error');
      setError(err.message);
      logError(err, { context: 'ForgotPassword handleSubmit' });
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        position: 'relative',
        background: 'linear-gradient(180deg, #0a0a0a 0%, #1a1a1a 50%, #0a0a0a 100%)',
      }}
    >
      {/* Background gradient overlay */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'radial-gradient(circle at 50% 0%, rgba(25, 118, 210, 0.15) 0%, transparent 50%)',
          pointerEvents: 'none',
          zIndex: 0,
        }}
      />
      <Container maxWidth="sm" sx={{ mt: 4, position: 'relative', zIndex: 1 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom align="center">
          Forgot Password
        </Typography>
        
        <Typography variant="body1" sx={{ mb: 3 }} align="center">
          Enter your email address and we'll send you a link to reset your password.
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }} data-test-id="forgot-password-error">
            {error}
          </Alert>
        )}

        {success && (
          <Alert severity="success" sx={{ mb: 2 }} data-test-id="forgot-password-success">
            {success}
          </Alert>
        )}

        <Box component="form" onSubmit={handleSubmit} data-test-id="forgot-password-form">
          <TextField
            fullWidth
            label="Email Address"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            margin="normal"
            required
            disabled={status === 'submitting'}
            inputProps={{ 'data-test-id': 'forgot-password-email' }}
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            size="large"
            sx={{ mt: 3 }}
            disabled={status === 'submitting'}
            data-test-id="forgot-password-submit"
          >
            {status === 'submitting' ? 'Sending...' : 'Send Reset Email'}
          </Button>

          <Box sx={{ mt: 2, textAlign: 'center' }}>
            <Link to="/login" style={{ textDecoration: 'none' }} data-test-id="forgot-password-back-to-login">
              <Typography variant="body2" color="primary">
                Back to Login
              </Typography>
            </Link>
          </Box>
        </Box>
      </Paper>
    </Container>
    </Box>
  );
}

export default ForgotPassword;